<app-page-header-nav
    [title]="title!"
    [navItems]="navItems"
></app-page-header-nav>
